import { Column, SortingRule } from 'react-table';

// Function Types
export type GetPkType<T> = (o: T) => string;
export type IsItemSelectedType<T> = (o: T) => boolean;
export type ToggleItemType<T> = (o: T) => void;
export type ToggleSelectAllType = () => void;
export type OnPageChangeType = (n: number) => void;
export type OnPageSizeChangeType = (n: number) => void;
export type OnSortCriteriaChangedType = (x: SortCriteria[]) => void;

export interface TableColumn extends Column {
  customizable?: boolean;
  defaultShow?: boolean;
}

export type IDataPage<T> = {
  pageNumber: number;
  items: T[];
  isFetching: boolean;
  isLoaded: boolean;
};

export const DataPageDefault = <T extends {}>(): IDataPage<T> => {
  return {
    pageNumber: 1,
    items: [],
    isFetching: false,
    isLoaded: false,
  };
};

export type IData<T> = {
  pages: IDataPage<T>[];
  pageSize: number;
  total: number;
  version: number;
};

export interface TablePagination {
  currentPage: number;
  numPages: number;
  pageSize: number;
}

export type ITable<T> = {
  content: T[];
  isLoading: boolean;
  pagination: TablePagination;
  columns: TableColumn[];
};

export interface ItemSelection<T> {
  isAllSelected: boolean;
  selectedKeys: string[];
  getPK: GetPkType<T>;
}

export type SortCriteria = SortingRule;

export type IDatatableState<T, FC> = {
  filters: FC;
  sort: SortCriteria[];
  selection: ItemSelection<T>;
  data: IData<T>;
  table: ITable<T>;
  pagesToLoad: number[];
};

export interface SearchPageResponse<T> {
  items: T[];
  total: number;
}

export interface SearchPageBasePayload {
  pageNumber: number;
  version: number;
}

export type SearchPageSuccessPayload<T> = SearchPageResponse<T> &
  SearchPageBasePayload;
export interface TablePageChangedPayload {
  pageNumber: number;
}

export interface TablePageSizeChangedPayload {
  pageSize: number;
}

export interface SortCriteriaPayload {
  sort: SortCriteria[];
}

export interface TableToggleItemPayload {
  item: any;
}
